import { render, staticRenderFns } from "./WeddingParty.vue?vue&type=template&id=18c419dd&scoped=true&"
import script from "./WeddingParty.vue?vue&type=script&lang=ts&"
export * from "./WeddingParty.vue?vue&type=script&lang=ts&"
import style0 from "./WeddingParty.vue?vue&type=style&index=0&id=18c419dd&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c419dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VCol,VContainer,VDivider,VImg,VRow,VSheet})
